import Model from './model';
import Card from './card';

export default class Subscription extends Model {
  static fields = [
    'id',
    { name: 'name', defaultValue: '' },
    { name: 'stripe_plan', mapping: (raw) => raw.stripe_plan, defaultValue: '' },
    { name: 'status', mapping: (raw) =>  raw.stripe_status, defaultValue: '' },
    'next',
    'time',
    'cancelled',
    'grace',
  ];
}